module.exports = __webpack_public_path__ + "img/2_3_5.2cdecd1c.png";